'use client';

function parseJSON(value) {
    try {
        if (!value)
            return;
        var parsedObject = JSON.parse(value);
        return parsedObject;
    }
    catch (error) {
        if (error instanceof SyntaxError) {
            // Handle SyntaxError specifically, like logging or returning a default value
            console.error('Invalid JSON format:', error.message);
            throw error; // Or any other appropriate default value
        }
        else {
            // Handle other potential errors
            console.error('Error parsing JSON:', error);
            throw error; // Re-throw the error for further handling
        }
    }
}

export { parseJSON };
//# sourceMappingURL=utilities.js.map
